import * as React from 'react';
import LoadingComponent from './Loading.component';

export default class LoadingContainer extends React.Component<{}, { text: string }> {

  public render(): React.ReactNode {
    return <LoadingComponent/>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/commons/loading/Loading.container.tsx